import React from 'react'
import { Box, Text } from '@usap/uicomponents'
import ChatWithUsContainer from './style/ChatWithUs.css'
import useIsWmoEnabled from "@usap/carparts/src/shared/hooks/useWmoEnabled"
import ChatWithUsWMO from './ChatWithUsWMO'

const ChatWithUs = ({
  text,
  linkText,
  OpenChatHandler,
}) => {
  const isWmoEnabled = useIsWmoEnabled()

  if(isWmoEnabled) {
    return(
      <ChatWithUsWMO 
        text={text}
        linkText={linkText}
        OpenChatHandler={OpenChatHandler}
      />
    )
  }

  return (
    <ChatWithUsContainer>
      <Text size="small">
        {text || 'Need help?'}
      </Text>
      <Box onClick={OpenChatHandler}>
        <Text size="small">
          {linkText || 'Chat with us'}
        </Text>
      </Box>
    </ChatWithUsContainer>
  )
}

export default ChatWithUs
